import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Blocks, Settings2 } from "lucide-react";
import { Button } from "../../components/tailwind/button";
import { WorkflowDefaultTriggerSettings } from "./components/WorkFlow/WorkflowDefaultTriggerSettings";
import { workflowTheme } from "./utils/workflowBuilderTheme";
import { whatsappPageShell, waShell } from "./utils/whatsappPageShell";
import { usePageTitle } from "../../hooks/usePageTitle";
import { WhatsAppPageIntro } from "./components/WhatsAppPageIntro";

const TABS = [
  // { id: "custom-actions", label: "Custom Actions", icon: Blocks },
  { id: "general", label: "General", icon: Settings2 }
];

export default function WorkflowSettings() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("general");
  usePageTitle("Workflow Settings");

  return (
    <div className={waShell(whatsappPageShell.focused, "animate-fade-in")}>
      <div className="animate-fade-in-up">
        <div className="flex items-start gap-3 mb-8">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className={`h-9 w-9 shrink-0 ${workflowTheme.backIconButton}`}
            onClick={() => navigate("/whatsapp/workflows")}
            aria-label="Back to workflows"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <WhatsAppPageIntro
            description="Configure default triggers and other workflow options."
            className="flex-1 !animate-none"
          />
        </div>

        <div className={`flex border-b ${workflowTheme.tabBar} mb-6 overflow-x-auto`}>
          {TABS.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              type="button"
              className={`px-4 py-2.5 text-sm font-medium border-b-2 flex items-center gap-2 whitespace-nowrap ${
                activeTab === id ? workflowTheme.tabActive : workflowTheme.tabInactive
              }`}
              onClick={() => setActiveTab(id)}
            >
              <Icon className="w-4 h-4" />
              {label}
            </button>
          ))}
        </div>

        {/* {activeTab === "custom-actions" && <CustomActionForm />} */}

        {activeTab === "general" && <WorkflowDefaultTriggerSettings />}
      </div>
    </div>
  );
}
